import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import './index.css';
import App from './App';

// App Bridge v4 is loaded via the CDN script in public/index.html. It reads the API
// key from the <meta name="shopify-api-key"> tag and exposes window.shopify globally,
// so no createApp/Provider is needed here. Session tokens come from
// window.shopify.idToken() (see src/utils/api.js).
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppProvider i18n={{}}>
        <App />
      </AppProvider>
    </BrowserRouter>
  </React.StrictMode>
);
